import { stakeholderService } from '../services'

export default (clientId, rut, password) => {
	return new Promise(resolve => {
		stakeholderService.getUser(clientId, rut, password)
			.then(response => {
				if(response) resolve({ success: true, data: response.data })
			})
			.catch(error => {
				if(error && error.response) resolve({ success: false, data: error.response.data })
			})
	})
}
